import { doClearValues } from '@databases/redux/contextual-menu/actions';
import { appStore } from '@databases/redux/store';

/**
 * This shared util is used by the context menu item to trigger the clearing
 * of values associated with the specified `contentId`.
 */
export function clearValues(contentId: string): void {
  appStore.dispatch(doClearValues(contentId));
}
